/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decoded header`)
};

const es_jw_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encabezado decodificado`)
};

const de_jw_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dekodierter Header`)
};

const nl_jw_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gedecodeerde header`)
};

const fr_jw_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En-tête décodé`)
};

const it_jw_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intestazione decodificata`)
};

const pt_br2_jw_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cabeçalho decodificado`)
};

const pt_jw_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cabeçalho descodificado`)
};

const ja_jw_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デコード済みヘッダー`)
};

const zh_jw_header_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解码后的头部`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_header_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_header_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_header_label", locale)
	if (locale === "en") return en_jw_header_label(inputs)
	if (locale === "es") return es_jw_header_label(inputs)
	if (locale === "de") return de_jw_header_label(inputs)
	if (locale === "nl") return nl_jw_header_label(inputs)
	if (locale === "fr") return fr_jw_header_label(inputs)
	if (locale === "it") return it_jw_header_label(inputs)
	if (locale === "pt-BR") return pt_br2_jw_header_label(inputs)
	if (locale === "pt") return pt_jw_header_label(inputs)
	if (locale === "ja") return ja_jw_header_label(inputs)
	return zh_jw_header_label(inputs)
};